import { createContext } from 'react'

const GateContext = createContext({
  gateIsOpen: false,
  closeGate: () => {},
  openGate: () => {},
})

export default GateContext
